import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_MULTI_TAXES, UPDATE_DEFAULT_MULTI_TAXES } from './constans';

export const getMultiTaxes = extendRoutine(createRoutine(GET_MULTI_TAXES), 'RESET');
export const updateDefaultTax = extendRoutine(createRoutine(UPDATE_DEFAULT_MULTI_TAXES), 'RESET');
